import { daysRemaining } from './daysRemaining';

export const hasExpired = (expiryDate: Date): boolean => daysRemaining(expiryDate) <= 0;
